
<template>
  <div>
    <span v-if="!order.client_id">Sem informações de faturamento</span>
    <v-radio-group v-if="order.client_id" v-model="order.other_client_cpf_cnpj" column>
      <v-radio label="Próprio cliente" :value="null"></v-radio>
      <v-radio v-for="(cli, idx) in billing_clients" :key="cli.cpf_cnpj" :label="`${cli.name}, ${cli.cpf_cnpj}`" :value="cli.cpf_cnpj"></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import Api from '@/api/index'

export default {
  name: 'SelectBillingClient',
  props: {
    order: {
      type: [Object],
    },
  },
  data() {
    return {
      billing: {
        other_client_cpf_cnpj: null,
      },
      billing_clients: [],
      loading_billing_clients: false,
    }
  },
  methods: {
    getData(){
      this.getClientBillingClients()
    },
    getClientBillingClients(){
      this.loading_billing_clients = true
      if (this.order.client_id){
        Api.Client.indexBillingClients(this.order.client_id).then(r=> r.data).then(c=>{
          this.billing_clients = [...c]
        }).catch(err=> {
          console.log({err})
        }).finally(()=>{
          this.loading_billing_clients = false
        })
      }
    },
  },
  mounted(){
    this.getData()
  },
  watch: {
    'order.client_id'(nv,ov) {
      if (nv){
        this.getData()
      }
    }
  },
}
</script>